(function(){
    'use strict';

    angular.module('elogbooks.admin.missed-patrol-reasons', []);
})();
